// THEME/LAYOUTS
export function UPDATE_CUSTOMISATION(state, data) {
  state.customisation = data
}

export function UPDATE_BETA_FEATURE_ACCESS(state, data) {
  state.betaFeatureAccess = data
}

export function UPDATE_CURRENT_LAYOUT1_HOME_TEMPLATE_ID(state, data) {
  state.currentLayout1HomeTemplateId = data
}

export function UPDATE_CONNECTIONS(state, data) {
  state.connections = data
}

export function UPDATE_TV_MODE(state, data) {
  state.TVMode = data
}

// TENANT POSTS
export function UPDATE_HOME_POSTS(state, data) {
  state.homePosts = data
}

// MIGRATIONS/HOOTMAIL
export function UPDATE_UPDATES_REQUIRED_COUNT(state, data) {
  state.updatesRequiredCount = data
}

// CLOUD
export function UPDATE_CURRENT_CLOUD_POST(state, data) {
  state.currentCloudPost = data
}

export function CLEAR_CURRENT_CLOUD_POST(state) {
  state.currentCloudPost = {}
}

// @todo fix set_saved_cloudposts - mutations/actions
export function UPDATE_SAVED_CLOUDPOSTS(state, data) {
  state.savedCloudPosts = data
}

export function UPDATE_CLOUD_TENANT_LEADERS(state, data) {
  state.cloudTenantLeaders = data
}

export function UPDATE_FILTER_CLOUD_BY(state, data) {
  if (data.resetAll) {
    state.filterCloudBy = {
      keywords: null,
      category: null,
      year: null,
      tag: null,
      industry: null,
      draft: null,
      region: null,
      old_events: null,
      order_events_by_publish_date: null,
      matchAll: false,
    }
  }

  if (data.reset) {
    const current_category = state.filterCloudBy.category
    // Reset all search data
    state.filterCloudBy = {
      keywords: null,
      category: current_category,
      year: null,
      tag: null,
      industry: null,
      draft: null,
      region: null,
      old_events: null,
      order_events_by_publish_date: null,
      matchAll: false,
    }
  }

  if (data.hasOwnProperty('category') && data.category !== 3) {
    state.filterCloudBy.old_events = null
    state.filterCloudBy.order_events_by_publish_date = null
  }

  if (data.showAllPosts) {
    state.filterCloudBy.category = null
  }

  if (data.hasOwnProperty('keywords')) {
    state.filterCloudBy.keywords = data.keywords
  }
  if (data.hasOwnProperty('category')) {
    state.filterCloudBy.category = data.category
  }
  if (data.hasOwnProperty('year')) {
    state.filterCloudBy.year = data.year
  }
  // @todo fix || null
  if (data.hasOwnProperty('region')) {
    state.filterCloudBy.region = data.region || null
  }
  if (data.hasOwnProperty('tag')) {
    state.filterCloudBy.tag = data.tag
  }
  if (data.hasOwnProperty('industry')) {
    state.filterCloudBy.industry = data.industry
  }
  if (data.hasOwnProperty('draft')) {
    state.filterCloudBy.draft = data.draft
  }
  // @todo fix || null
  if (data.hasOwnProperty('old_events')) {
    state.filterCloudBy.old_events = data.old_events || null
  }
  // @todo fix || null
  if (data.hasOwnProperty('order_events_by_publish_date')) {
    state.filterCloudBy.order_events_by_publish_date =
      data.order_events_by_publish_date || null
  }
  if (data.hasOwnProperty('matchAll')) {
    state.filterCloudBy.matchAll = data.matchAll
  }
}

// MAIL
export function UPDATE_FOLLOWERS(state, data) {
  state.followers = data
}

export function UPDATE_FOLLOWERS_BOUNCED(state, data) {
  state.followersBounced = data
}

export function UPDATE_FOLLOWERS_LISTLESS(state, data) {
  state.followersListless = data
}

export function UPDATE_MAIL_LISTS(state, data) {
  state.mailLists = data
}

export function UPDATE_MAIL_LISTS_HAIL(state, data) {
  state.mailListsHail = data
}

export function UPDATE_NEWSLETTER_POSTS(state, data) {
  state.newsletterPosts = data
}

export function UPDATE_NEWSLETTER_SELECTED_POSTS(state, data) {
  state.newsletterSelectedPosts = data
}

export function CLEAR_NEWSLETTER_SELECTED_POSTS(state) {
  state.newsletterSelectedPosts = []
}

export function UPDATE_AUTO_NEWSLETTER_STATUS(state, data) {
  state.autoNewsletterStatus = data
}

export function CLEAR_AUTO_NEWSLETTER_STATUS(state) {
  state.autoNewsletterStatus = null
}

export function UPDATE_SCHOOLS_LIST(state, data) {
  state.schoolsList = data
}

export function CLEAR_SCHOOLS_LIST(state) {
  state.schoolsList = []
}
